import { useTranslation } from "react-i18next";

export default function AvatarViewportLoader({ label }) {
  const { t } = useTranslation();
  const text = label || t("common.loading");

  return (
    <div
      className="absolute inset-0 z-[2] grid place-items-center bg-[rgba(8,5,40,0.35)]"
      role="status"
      aria-live="polite"
      aria-label={text}
    >
      <div className="flex flex-col items-center gap-2">
        <span className="h-8 w-8 animate-spin rounded-full border-2 border-[rgba(52,203,255,0.22)] border-t-[#34cbff]" />
        <span className="text-[11px] text-[#9b96c9]">{text}</span>
      </div>
    </div>
  );
}
